import { Card, Col, Row } from 'react-bootstrap';
import { useFormat } from '../../../../components/FormatContext';

const SupplierRentalPolicyCard = ({ booking }) => {
    const { formatCurrency } = useFormat();
    return (
        <Card className="shadow-sm border-0 mt-4">
            <Card.Header className="bg-white fw-semibold">Rental Policy</Card.Header>
            <Card.Body>
                <Row className="g-3">
                    <Col md={6}>
                        <div className="text-muted small">Deposit</div>
                        <div>{formatCurrency(booking.deposit, booking.currencyCode)}</div>
                    </Col>

                    <Col md={6}>
                        <div className="text-muted small">Theft Excess</div>
                        <div>{formatCurrency(booking.theftExcess, booking.currencyCode)}</div>
                    </Col>

                    <Col md={6}>
                        <div className="text-muted small">Damage Excess</div>
                        <div>{formatCurrency(booking.damageExcess, booking.currencyCode)}</div>
                    </Col>

                    <Col md={6}>
                        <div className="text-muted small">Mileage Limit</div>
                        <div>{booking.isUnlimitedMileage ? 'Unlimited' : (booking.mileageLimit || '-')}</div>
                    </Col>

                    <Col md={6}>
                        <div className="text-muted small">Excess Mileage Fee</div>
                        <div>
                            {booking.excessMileageFee !== '' && booking.excessMileageFee !== null && booking.excessMileageFee !== undefined
                                ? `${booking.excessMileageFee} / km`
                                : '-'}
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="text-muted small">Unlimited Mileage</div>
                        <div>{booking.isUnlimitedMileage ? 'Yes' : 'No'}</div>
                    </Col>
                </Row>

                <hr />

                <Row className="g-3">
                    <Col md={6}>
                        <div className="text-muted small">Refund within 7 days</div>
                        <div>{booking.cancellation7DaysRefund}%</div>
                    </Col>

                    <Col md={6}>
                        <div className="text-muted small">Refund within 15 days</div>
                        <div>{booking.cancellation15DaysRefund}%</div>
                    </Col>

                    <Col md={6}>
                        <div className="text-muted small">Refund within 30 days</div>
                        <div>{booking.cancellation30DaysRefund}%</div>
                    </Col>

                    <Col md={6}>
                        <div className="text-muted small">Refund within 60 days</div>
                        <div>{booking.cancellation60DaysRefund}%</div>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default SupplierRentalPolicyCard;